import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import PopSnackbar from "../../../../components/snackbar/Snackbar";
import CC417 from "./cc_components/CC417";
import CC503 from "./cc_components/CC503";
import CC413 from "./cc_components/CC413";
import CC504 from "./cc_components/CC504";
import CC414 from "./cc_components/CC414";
import CC446 from "./cc_components/CC446";
import {
  CreateCC417DeclarationH7,
  CreateCC503DeclarationH7,
  CreateCC413DeclarationH7,
  CreateCC504DeclarationH7,
  CreateCC414DeclarationH7,
  CreateCC446DeclarationH7,
  GetImportH7S2SDeclarationInfo,
  GetImportH7S2SDeclarationInfoForCC413,
  GetImportH7S2SDeclarationInfoForCC446,
} from "../../../../services/import/h7/s2s/create";

export default function UploadCCS2S({ selectedOfficeID }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [description, setDescription] = useState("");
  const [data, setData] = useState({});
  const [declarationInfo, setDeclarationInfo] = useState(null);

  const { declarationId, ccType, ccMessage } = location.state || {};

  async function submitForm(values) {
    try {
      setLoading(true);
      const bodyData = values.data || values;
      const jsonValues = JSON.stringify(bodyData);
      let response;

      switch (ccType) {
        case "CC417":
          response = await CreateCC417DeclarationH7(
            selectedOfficeID,
            jsonValues,
            declarationId
          );
          break;
        case "CC503":
          response = await CreateCC503DeclarationH7(
            selectedOfficeID,
            jsonValues,
            declarationId
          );
          break;
        case "CC413":
          response = await CreateCC413DeclarationH7(
            selectedOfficeID,
            jsonValues,
            declarationId
          );
          break;
        case "CC504":
          response = await CreateCC504DeclarationH7(
            selectedOfficeID,
            jsonValues,
            declarationId
          );
          break;
        case "CC414":
          response = await CreateCC414DeclarationH7(
            selectedOfficeID,
            jsonValues,
            declarationId
          );
          break;
        case "CC446":
          response = await CreateCC446DeclarationH7(
            selectedOfficeID,
            jsonValues,
            declarationId
          );
          break;
      }

      if (response.status !== "OK") {
        throw new Error(
          response.error || "Something went wrong, please try again later."
        );
      }

      handleStatus(
        "Declaration has been successfully submitted",
        setError,
        setDescription
      );
    } catch (error) {
      handleStatus(error.message, setError, setDescription);
    } finally {
      navigate(-1);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!declarationId || !ccType) {
      navigate(-1);
    }

    // Fetch declaration info for CC417, CC503, and CC413
    if (
      ccType === "CC417" ||
      ccType === "CC503" ||
      ccType === "CC414" ||
      ccType === "CC504"
    ) {
      getDeclarationInfo();
    } else if (ccType === "CC413") {
      getDeclarationInfoForCC413();
    } else if (ccType === "CC446") {
      getDeclarationInfoForCC446();
    }
  }, []);

  async function getDeclarationInfo() {
    try {
      setLoading(true);
      const response = await GetImportH7S2SDeclarationInfo(
        selectedOfficeID,
        declarationId
      );
      if (response.status !== "OK") {
        throw new Error(response.error || "Failed to fetch declaration info");
      }
      setDeclarationInfo(response.data);
    } catch (error) {
      handleStatus(error.message, setError, setDescription);
    } finally {
      setLoading(false);
    }
  }

  async function getDeclarationInfoForCC413() {
    try {
      setLoading(true);
      const response = await GetImportH7S2SDeclarationInfoForCC413(
        selectedOfficeID,
        declarationId
      );
      if (response.status !== "OK") {
        throw new Error(response.error || "Failed to fetch declaration info");
      }
      setDeclarationInfo(response.data);
    } catch (error) {
      handleStatus(error.message, setError, setDescription);
    } finally {
      setLoading(false);
    }
  }

  async function getDeclarationInfoForCC446() {
    try {
      setLoading(true);
      const response = await GetImportH7S2SDeclarationInfoForCC446(
        selectedOfficeID,
        declarationId
      );
      if (response.status !== "OK") {
        throw new Error(response.error || "Failed to fetch declaration info");
      }
      // Store both declaration data and cc438_info (array of requested documents)
      setDeclarationInfo({
        ...response.data,
        cc438_info_list: response.cc438_info || [],
      });
    } catch (error) {
      handleStatus(error.message, setError, setDescription);
    } finally {
      setLoading(false);
    }
  }

  // async function getDeclarationData() {
  //   try {
  //     setLoading(true);
  //     const response = await fetchImportDeclarationData(
  //       declarationId,
  //       selectedOfficeID
  //     );
  //     if (response.status !== "OK") {
  //       throw new Error(
  //         response.error || "Something went wrong, please try again later."
  //       );
  //     }
  //     setData(response.data);
  //   } catch (error) {
  //     handleStatus(error.message, setError, setDescription);
  //   } finally {
  //     setLoading(false);
  //   }
  // }

  const handleStatus = (description, setStatus, setDescription) => {
    setStatus(true);
    setDescription(description);
    setTimeout(() => {
      setStatus(false);
      setDescription("");
    }, 5000);
  };

  const switchCCDeclaration = (ccType) => {
    switch (ccType) {
      case "CC417":
        return (
          <CC417 submitForm={submitForm} declarationInfo={declarationInfo} />
        );
      case "CC503":
        return (
          <CC503 submitForm={submitForm} declarationInfo={declarationInfo} />
        );
      case "CC413":
        return (
          <CC413 submitForm={submitForm} declarationInfo={declarationInfo} />
        );
      case "CC504":
        return (
          <CC504 submitForm={submitForm} declarationInfo={declarationInfo} />
        );
      case "CC414":
        return (
          <CC414 submitForm={submitForm} declarationInfo={declarationInfo} />
        );
      case "CC446":
        return (
          <CC446 submitForm={submitForm} declarationInfo={declarationInfo} />
        );
    }
  };

  if (!declarationId || !ccType) {
    return <div>Work in progress!</div>;
  }

  return (
    <div>
      <h1 style={{ fontFamily: "SeagoeUIBold" }}>
        {ccType} -{" "}
        {ccMessage?.normalize("NFD").replace(/[\u0300-\u036f]/g, "") ||
          "Import Declaration S2S"}
      </h1>

      {error && <PopSnackbar message={description} />}

      {loading ? (
        <CircularProgress style={{ alignSelf: "center" }} />
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 10,
            marginTop: 20,
            backgroundColor: "transparent",
          }}
        >
          {switchCCDeclaration(ccType)}
        </div>
      )}
    </div>
  );
}
